import { Discord, Twitter, Github } from '@drift-labs/icons';
import { DRIFT_DISCORD_URL } from 'src/constants/constants';

export const MORE_CATEGORY_GENERAL_LINKS = [
	{
		label: 'Disclaimers',
		href: 'https://docs.drift.trade/legal-and-regulations/disclaimer',
	},
	{
		label: 'Terms',
		href: 'https://docs.drift.trade/legal-and-regulations/terms-of-use',
	},
	{
		label: 'Data Policy',
		href: '/data-policy',
	},
	{
		label: 'Docs',
		href: 'https://docs.drift.trade',
	},
];

export const MORE_CATEGORY_SOCIAL_LINKS = [
	{
		icon: Discord,
		href: DRIFT_DISCORD_URL,
	},
	{
		icon: Twitter,
		href: 'https://twitter.com/DriftProtocol',
	},
	{
		icon: Github,
		href: 'https://github.com/drift-labs',
	},
];
